import { Divider, Empty, Image } from "antd";
import "./style.scss";
import { getStatusTag } from "./CustomTag";
import { FaTruckMoving } from "react-icons/fa6";
import { FaRegFolderOpen } from "react-icons/fa6";
import { FaUndoAlt, FaUserFriends } from "react-icons/fa";
import { GiReturnArrow } from "react-icons/gi";

type PropsType = {
  initialValue: any;
};
export const DetailsOt = ({ initialValue }: PropsType) => {

  const InfoItem = ({
    label,
    value,
    link = false,
  }: {
    label: string;
    value?: React.ReactNode;
    link?: boolean;
  }) => {
    if (!value) return null;
  
    return (
      <div className="details__item">
        <span className="details__label">{label}</span>
        {link ? (
          <span className="details__value_link">{value}</span>
        ) : (
          <span className="details__value">{value}</span>
        )}
      </div>
    );
  };
  
  return (
    <>
    {/* <div className="d-flex flex-column gap-2">
      <div className="">
        <div className="">
          <span className="details__title">ORDRE DE TRANSPORT : </span>
          <span className="details__value">{initialValue?.reference}</span>
        </div>
        <div className="">
          <span className="details__subtitle">Status : </span>
          <span className="details__value">
            {getStatusTag(
              initialValue?.transportOrderState?.id,
              initialValue?.transportOrderState?.name
            )}
            {}
          </span>
        </div>
      </div> */}

      {/* Creation OT  */}
      {/* <div className="">
        <Divider orientation="left">
          <div className="details__title_container">
            <FaRegFolderOpen className="details__icon" />
            <div>Création de l'ordre de transport</div>
          </div>
        </Divider>
        <div className="d-flex">
          <div className="d-flex flex-column w-25">
            <span className="details__label">Client :</span>
            <span className="details__value">
              {initialValue?.customer?.name}
            </span>
          </div>
          <div className="d-flex flex-column w-25">
            <span className="details__label">Conteneur :</span>
            <span className="details__value">
              {initialValue?.storageLoad?.uniqueIdentifierLoad}
            </span>
          </div>
          <div className="d-flex flex-column w-25">
            <span className="details__label">Facture (PJ) :</span>
            <a
              href={initialValue?.invoiceFile?.contentUrl}
              target="_blank"
              className="details__value_link"
            >
              {initialValue?.invoiceFile?.basename}
            </a>
          </div>
          <div className="d-flex flex-column w-25">
            <span className="details__label">Bon de livraison (PJ) : </span>
            <a
              href={initialValue?.deliveryNoteFile?.contentUrl}
              target="_blank"
              className="details__value_link"
            >
              {initialValue?.deliveryNoteFile?.basename}
            </a>
          </div>
        </div>
      </div> */}

      {/* Assignation truck  */}
      {/* <div className="">
        <Divider orientation="left">
          <div className="details__title_container">
            <FaTruckMoving className="details__icon" />
            <div>Assignation au camion</div>
          </div>
        </Divider>
        <div className="d-flex">
          <div className="d-flex flex-column w-25">
            <span className="details__label">Camion :</span>
            <span className="details__value">
              {initialValue?.truck?.reference || initialValue?.particularTruckNumber}
            </span>
          </div>
          <div className="d-flex flex-column w-25">
            <span className="details__label">Chauffeur :</span>
            <span className="details__value">
              {initialValue?.truck?.driver?.fullname || initialValue?.particularDriverName}
            </span>
          </div>
          <div className="d-flex flex-column w-25">
            <span className="details__label">Date de livraison :</span>
            <span className="details__value">{initialValue?.deliveryDate}</span>
          </div>
          <div className="d-flex flex-column w-25">
            <span className="details__label">Lieu de livraison :</span>
            <span className="details__value">
              {initialValue?.deliveryLocation}
            </span>
          </div>
          <div className="d-flex flex-column w-25">
            <span className="details__label">
              Date de restitution du conteneur vide :{" "}
            </span>
            <span className="details__value">
              {initialValue?.emptyTCrecoveryDate}
            </span>
          </div>
        </div>
      </div> */}

      {/* Enlevement customer  */}
      {/* {initialValue?.customerRemovalControl ? (
        <div className="">
          <Divider orientation="left">
            <div className="details__title_container">
              <FaUserFriends className="details__icon" />
              <div>Enlèvement client</div>
            </div>
          </Divider>
          <div className="details__card">
            <div className="d-flex">
              <div className="d-flex flex-column w-25">
                <span className="details__label">Fait par :</span>
                <span className="details__value">
                  {initialValue?.customerRemovalControl?.checkedBy?.fullname}
                </span>
              </div>
              <div className="d-flex flex-column w-25">
                <span className="details__label">Machine :</span>
                <span className="details__value">
                  {initialValue?.customerRemovalControl?.machine?.reference}
                </span>
              </div>
              <div className="d-flex flex-column w-25">
                <span className="details__label">Date :</span>
                <span className="details__value">
                  {initialValue?.customerRemovalControl?.createdAt}
                </span>
              </div>
            </div>

            <div className="d-flex flex-column mt-4">
              <span className="details__label">Commentaire :</span>
              <span className="details__value">
                {initialValue?.customerRemovalControl?.comment}
              </span>
            </div>

            <div className="d-flex flex-column mt-4">
              <span className="details__label">Images :</span>

              <Image.PreviewGroup
                preview={{
                  onChange: (current, prev) =>
                    console.log(
                      `current index: ${current}, prev index: ${prev}`
                    ),
                }}
              >
                {initialValue?.customerRemovalControl?.images?.map(
                  (img: any, index: number) => (
                    <div className="details__image_item">
                    <Image
                      key={index}
                      height={200}
                      width={250}
                      style={{
                        borderRadius: "8px",
                        objectFit: "cover",
                        border: "solid #f4f4f4 1px",
                      }}
                      src={img.contentUrl}
                    />
                    </div>
                  )
                )}
              </Image.PreviewGroup>
            </div>
          </div>
        </div>
      ) : (
        ""
      )} */}

      {/* Restitution  */}
      {/* {initialValue?.restitutionControl ? (
        <div className="">
          <Divider orientation="left">
            <div className="details__title_container">
              <GiReturnArrow className="details__icon" />
              <div>Restitution</div>
            </div>
          </Divider>
          <div className="details__card">
            <div className="d-flex">
              <div className="d-flex flex-column w-25">
                <span className="details__label">Fait par :</span>
                <span className="details__value">
                  {initialValue?.restitutionControl?.checkedBy?.fullname}
                </span>
              </div>
              <div className="d-flex flex-column w-25">
                <span className="details__label">Machine :</span>
                <span className="details__value">
                  {initialValue?.restitutionControl?.machine?.reference}
                </span>
              </div>
              <div className="d-flex flex-column w-25">
                <span className="details__label">Date :</span>
                <span className="details__value">
                  {initialValue?.restitutionControl?.createdAt}
                </span>
              </div>

              <div className="d-flex flex-column w-25">
                <span className="details__label">Lieu de restitution :</span>
                <span className="details__value">
                  {initialValue?.restitutionControl?.destination?.name}
                </span>
              </div>
            </div>

            <div className="d-flex flex-column mt-4">
              <span className="details__label">Commentaire :</span>
              <span className="details__value">
                {initialValue?.restitutionControl?.comment}
              </span>
            </div>

            <div className="d-flex flex-column mt-4">
              <span className="details__label">Images :</span>

              <Image.PreviewGroup
                preview={{
                  onChange: (current, prev) =>
                    console.log(
                      `current index: ${current}, prev index: ${prev}`
                    ),
                }}
              >
                {initialValue?.restitutionControl?.images?.map(
                  (img: any, index: number) => (
                    <div className="details__image_item">
                      <Image
                      key={index}
                      height={200}
                      width={250}
                      style={{
                        borderRadius: "8px",
                        objectFit: "cover",
                        border: "solid #f4f4f4 1px",
                      }}
                      src={img.contentUrl}
                    />
                    </div>
                  )
                )}
              </Image.PreviewGroup>
            </div>
          </div>
        </div>
      ) : (
        ""
      )}
    </div> */}

<div className="details__header">
  <div>
    <span className="details__title">Ordre de transport</span>
    <span className="details__reference">{initialValue?.reference}</span>
  </div>

  <div>
    {getStatusTag(
      initialValue?.transportOrderState?.id,
      initialValue?.transportOrderState?.name
    )}
  </div>
</div>


<Divider orientation="left" style={{borderColor: "rgba(0, 0, 0, 0.2)"}}>
  <div className="details__title_container">
    <FaRegFolderOpen className="details__icon" />
    Création de l’ordre de transport
  </div>
</Divider>

<div className="details__card details__grid">
  <InfoItem label="Client" value={initialValue?.customer?.name} />
  <InfoItem
    label="Conteneur"
    value={initialValue?.storageLoad?.uniqueIdentifierLoad}
  />
  <InfoItem
    label="Facture (PJ)"
    value={
      <a href={initialValue?.invoiceFile?.contentUrl} target="_blank">
        {initialValue?.invoiceFile?.basename}
      </a>
    }
    link
  />
  <InfoItem
    label="Bon de livraison (PJ)"
    value={
      <a href={initialValue?.deliveryNoteFile?.contentUrl} target="_blank">
        {initialValue?.deliveryNoteFile?.basename}
      </a>
    }
    link
  />
</div>


<Divider orientation="left" style={{borderColor: "rgba(0, 0, 0, 0.2)", marginTop:"40px"}}>
  <div className="details__title_container">
    <FaTruckMoving className="details__icon" />
    Assignation au camion
  </div>
</Divider>

<div className="details__card details__grid">
  {initialValue.transportOrderState.id !== "CREATED" ? (
    <>
      <InfoItem
    label="Camion"
    value={
      initialValue?.truck?.reference ||
      initialValue?.particularTruckNumber
    }
  />
  <InfoItem
    label="Chauffeur"
    value={
      initialValue?.truck?.driver?.fullname ||
      initialValue?.particularDriverName
    }
  />
  <InfoItem label="Date de livraison" value={initialValue?.deliveryDate} />
  <InfoItem label="Lieu de livraison" value={initialValue?.deliveryLocation} />
  <InfoItem
    label="Restitution conteneur vide"
    value={initialValue?.emptyTCrecoveryDate}
  />
    </>
  ) : <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={"En attente d’assignation du camion"} />}
</div>



{initialValue?.customerRemovalControl && (
  <>
    <Divider orientation="left" style={{borderColor: "rgba(0, 0, 0, 0.2)", marginTop:"40px"}}>
      <div className="details__title_container">
        <FaUserFriends className="details__icon" />
        Enlèvement client
      </div>
    </Divider>

    <div className="details__card">
      <div className="details__grid">
        <InfoItem
          label="Fait par"
          value={initialValue?.customerRemovalControl?.checkedBy?.fullname}
        />
        <InfoItem
          label="Machine"
          value={initialValue?.customerRemovalControl?.machine?.reference}
        />
        <InfoItem
          label="Date"
          value={initialValue?.customerRemovalControl?.createdAt}
        />
      </div>

      <div className="details__comment">
        <span className="details__label">Commentaire</span>
        <p>{initialValue?.customerRemovalControl?.comment}</p>
      </div>

      <div className="details__images">
        <Image.PreviewGroup>
          {initialValue?.customerRemovalControl?.images?.map(
            (img: any, index: number) => (
              <Image key={index} src={img.contentUrl} />
            )
          )}
        </Image.PreviewGroup>
      </div>
    </div>
  </>
)}

{initialValue?.restitutionControl && (
  <>
    <Divider orientation="left" style={{borderColor: "rgba(0, 0, 0, 0.2)", marginTop:"40px"}}>
      <div className="details__title_container">
        <FaUndoAlt className="details__icon" />
        Restitution
      </div>
    </Divider>

    <div className="details__card">
      {/* Infos principales */}
      <div className="details__grid">
        <InfoItem
          label="Fait par"
          value={initialValue?.restitutionControl?.checkedBy?.fullname}
        />
        <InfoItem
          label="Machine"
          value={initialValue?.restitutionControl?.machine?.reference}
        />
        <InfoItem
          label="Date"
          value={initialValue?.restitutionControl?.createdAt}
        />
        <InfoItem
          label="Lieu de restitution"
          value={initialValue?.restitutionControl?.destination?.name}
        />
      </div>

      {/* Commentaire */}
      {initialValue?.restitutionControl?.comment && (
        <div className="details__comment">
          <span className="details__label">Commentaire</span>
          <p>{initialValue?.restitutionControl?.comment}</p>
        </div>
      )}

      {/* Images */}
      {initialValue?.restitutionControl?.images?.length > 0 && (
        <div className="details__images">
          <Image.PreviewGroup>
            {initialValue?.restitutionControl?.images.map((img: any, index: number) => (
              <Image
                key={index}
                src={img.contentUrl}
                width={240}
                height={180}
                style={{ objectFit: "cover", borderRadius: "8px" }}
              />
            ))}
          </Image.PreviewGroup>
        </div>
      )}
    </div>
  </>
)}

   </>
  );
};
